module.exports = __webpack_public_path__ + "static/img/img_IPmin_4.faf026c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/img_IPmin_4.png
// module id = xoXV
// module chunks = 0